import * as React from "react";
import AddEvidenceModal from "security-app/components/Investigations/plugin/shared/AddEvidenceModal";
import { useModalContext } from "common/contexts";
import EventDefinitionCreateHOC from "security-app/components/SecurityEvents/Alerts/AlertsModals/EventDefinitionCreateHOC";
import SystemAlertsDetails from "security-app/components/Welcome/WelcomeModals/SystemAlertsDetails";
import SetOwner from "./UsersModal";
import ConfirmStatusChange from "./ConfirmStatusChange";
import ConfirmOwnerRemove from "./ConfirmOwnerRemove";
import NotesModal from "./NotesModal";
import SendNotification from "./NotificationsModal/SendNotification";
import EventDefinitionHOC from "./EventDefinitionHOC";
function AlertsModals() {
  const { modal, setModal, entity: eventIds, setEntity } = useModalContext();
  const onAddEvidenceClose = () => {
    setModal(null);
    setEntity(null);
  };
  switch (modal) {
    case "ADD-EVIDENCE":
      return /* @__PURE__ */ React.createElement(AddEvidenceModal, { show: true, type: "events", ids: eventIds, onClose: onAddEvidenceClose });
    case "SELECT-OWNER":
      return /* @__PURE__ */ React.createElement(SetOwner, null);
    case "CONFIRM-STATUS-CHANGE":
      return /* @__PURE__ */ React.createElement(ConfirmStatusChange, null);
    case "CONFIRM-OWNER-REMOVE":
      return /* @__PURE__ */ React.createElement(ConfirmOwnerRemove, null);
    case "NOTES-EDITOR":
      return /* @__PURE__ */ React.createElement(NotesModal, null);
    case "SEND-NOTIFICATION":
      return /* @__PURE__ */ React.createElement(SendNotification, null);
    case "EVENT-DEFINITION":
      return /* @__PURE__ */ React.createElement(EventDefinitionHOC, null);
    case "EVENT-DEFINITION-CREATE":
      return /* @__PURE__ */ React.createElement(EventDefinitionCreateHOC, null);
    case "SYSTEM_ALERTS_DETAILS":
      return /* @__PURE__ */ React.createElement(SystemAlertsDetails, { notifications: eventIds, onClose: onAddEvidenceClose });
    default:
      return null;
  }
}
export default AlertsModals;
